import React from "react";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton, TextField, Box, Typography } from "@mui/material";
import DeleteIcon from "../../../../styles/svg/adminWorkflowDelete.svg"
import FormDialog from "../../../../components/Dialog/FormDialog";
import { useManageTeams } from "../hooks/useManageTeams";

function ManageTeams() {
    const {
        teamList,
        isTeamsLoading,
        editingTeamId,
        editedTeamName,
        isDeleteDialogOpen,
        handleEditClick,
        handleUpdateTeam,
        handleTeamNameChange,
        handleKeyPress,
        handleDeleteClick,
        closeDeleteDialog,
        submitDelete,
    } = useManageTeams();

    if (isTeamsLoading) {
        return <div>Loading...</div>;
    }

    return (
        <Box>
            {isDeleteDialogOpen && (
                <FormDialog
                    open={isDeleteDialogOpen}
                    handleClose={closeDeleteDialog}
                    title={"Confirmation: Delete Team"}
                    buttonTxt={"Delete"}
                    cancelBtn={true}
                    handleSubmit={submitDelete}
                    fullWidth={true}>
                    <Typography className="align_text_center mb-2">
                        Are you sure you want to delete this team?
                    </Typography>
                </FormDialog>
            )}
            {!teamList.length && (
                <Typography color="text.secondary">No teams found.</Typography>
            )}
            {teamList.map((team) => (
                <Box
                    key={team.team_id}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1,
                    }}
                >
                    {editingTeamId === team.team_id ? (
                        <TextField
                            value={editedTeamName}
                            onChange={handleTeamNameChange}
                            onKeyPress={(e) => handleKeyPress(e, team.team_id)}
                            onBlur={() => handleUpdateTeam(team.team_id)}
                            autoFocus
                            size="small"
                            sx={{ flex: 1 }}
                        />
                    ) : (
                        <Typography flex={1}>{team.team}</Typography>
                    )}
                    <IconButton
                        size="small"
                        onClick={() => handleEditClick(team)}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={() => handleDeleteClick(team.team_id)}
                    >
                        <img src={DeleteIcon} alt="Delete team" />
                    </IconButton>
                </Box>
            ))}
        </Box>
    );
}

export default ManageTeams;
